import i18n from '../../../i18n';

export const partReplacementsReportFields = [
    "modelCode",
    "serialNumber",
    "inventoryNumber",
    "ip",
    "location",
    "partType",
    "partModelCode",
    "replacementDate"
];

export const partReplacementsReportConfig = {
    code : 'PART_REPLACEMENTS',
    gridStateKey: 'gridReportPartReplacements',
    filter: {
        getter: 'partReplacementsFilter',
        mutation: 'setPartReplacementsFilter'
    },
    columns: [{
        id: 1,
        dataField : 'modelCode',
        caption : i18n.t('report.titleReports.partReplacements.modelCode'),
        dataType : 'string',
        sortOrder: 10
    }, {
        id: 2,
        dataField : 'serialNumber',
        caption : i18n.t('report.titleReports.partReplacements.serialNumber'),
        dataType : 'string',
        sortOrder: 20
    }, {
        id: 3,
        dataField : 'inventoryNumber',
        caption : i18n.t('report.titleReports.partReplacements.inventoryNumber'),
        dataType : 'string',
        sortOrder: 30
    }, {
        id: 4,
        dataField : 'ip',
        caption : i18n.t('report.titleReports.partReplacements.ip'),
        dataType : 'string',
        sortOrder: 40
    }, {
        id: 5,
        dataField : 'location',
        caption : i18n.t('report.titleReports.partReplacements.location'),
        dataType : 'string',
        sortOrder: 50
      }, {
        id: 6,
        dataField : 'partType',
        caption : i18n.t('report.titleReports.partReplacements.partType'),
        dataType : 'string',
        sortOrder: 60
      }, {
        id: 7,
        dataField : 'partModelCode',
        caption : i18n.t('report.titleReports.partReplacements.partModelCode'),
        dataType : 'string',
        sortOrder: 70
      }, {
        id: 8,
        dataField : 'replacementDate',
        caption : i18n.t('report.titleReports.partReplacements.replacementDate'),
        dataType : 'date',
        format : 'dd.MM.yyyy HH:mm:ss',
        sortOrder: 80
      }]
}
